import template from './loanAmountForAliModal.html';
import controller from './loanAmountForAliModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    clientId: '<',
  },
};
